/**
 * workTemplate | 案例模版
 *name: '', | 案例名称（10字数内）
 *cover: '', | 案例封面图
 *date: '', | 时间
 *partner: '', | 合作方
 *appType: '', | 程序类型（小程序，app，网站……）
 *industryType: '', | 行业类型
 *describe: '', | 案例描述
 *banner: [], | 详情图片
 *bannerType: '', | mobile or pc
 */

const workTemplate = {
  name: null,
  cover: null,
  date: null,
  partner: null,
  appType: null,
  industryType: null,
  describe: null,
  banner: [],
  bannerType: null,
}

/* 主要展示案例 */

const work1 = {
  name: '广告交易网',
    cover: require('@/assets/images/worksPics/w1-cover.jpg'),
  date: '2015年7月',
  partner: '国家工商总局广告监督管理司',
  appType: 'web网站',
  industryType: '电商平台/广告交易',
  describe: '官方认证广告交易平台。中国电视、广播、报纸媒体广告交易、审核一体化平台。',
  banner: [
      require('@/assets/images/worksPics/w1-b1.jpg'),
      require('@/assets/images/worksPics/w1-b2.jpg'),
      require('@/assets/images/worksPics/w1-b3.jpg')
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '在线展示', url:'https://ggbao.lab.rollong.com/'},
        { intro: '管理后台（18019101985，password）', url:'https://ggbao.lab.rollong.com/admin'},
    ]
}

const work2 = {
  name: '工商总局广告监督中心',
    cover: require('@/assets/images/worksPics/w2-cover.jpg'),
  date: '2015年10月',
  partner: '国家工商总局广告监督管理司',
  appType: 'web网站',
  industryType: '政府发布',
  describe: '辅助加强广播电视管理，发展广播电视事业。',
  banner: [
      require('@/assets/images/worksPics/w2-b1.jpg'),
      require('@/assets/images/worksPics/w2-b2.jpg')
  ],
  bannerType: 'pc',
}

const work3 = {
  name: '西南交通大学设备管理',
    cover: require('@/assets/images/worksPics/w3-cover.jpg'),
  date: '2013年9月',
  partner: '西南交通大学',
  appType: 'web网站',
  industryType: '教育',
  describe: '国家重点实验室网络化建设，实验室设备和人员信息管理，高效的移动通知系统',
  banner: [
      require('@/assets/images/worksPics/w3-cover.jpg')
  ],
  bannerType: 'pc',
}

const work4 = {
  name: '一庐工作室',
    cover: require('@/assets/images/worksPics/w4-cover.jpg'),
  date: '2014年1月',
  partner: '一庐文化传播',
  appType: 'web网站',
  industryType: '艺术',
  describe: '一庐官网，在线艺术社区，画廊、展览、艺术书店',
  banner: [
      require('@/assets/images/worksPics/w4-b1.jpg'),
      require('@/assets/images/worksPics/w4-b2.jpg'),
      require('@/assets/images/worksPics/w4-b3.jpg'),
      require('@/assets/images/worksPics/w4-b4.jpg')
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '在线展示', url:'https://illu-art.app.rollong.com/'}
    ]
}

const work5 = {
  name: '激战订场约战平台',
    cover: require('@/assets/images/worksPics/w5-cover.jpg'),
  date: '2014年5月',
  partner: '成都乐想',
  appType: '微信/web网站',
  industryType: '体育',
  describe: '成都本地足球类O2O，赛事承办、本地订场、球队约战',
  banner: [
      require('@/assets/images/worksPics/w5-b1.jpg'),
      require('@/assets/images/worksPics/w5-b2.jpg'),
      require('@/assets/images/worksPics/w5-b3.jpg'),
      require('@/assets/images/worksPics/w5-b4.jpg')
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '在线展示', url:'http://jzhan2.lab.rollong.com/assets/mobile/stale/jzhan2.0/'},
        { intro: '管理后台（0001，qweasdzxc）', url:'http://jzhan2.lab.rollong.com/admin'},
    ]
}

const work6 = {
  name: '农场来了',
    cover: require('@/assets/images/worksPics/w6-cover.jpg'),
  date: '2014年6月',
  partner: '四川省电商协会',
  appType: 'web网站',
  industryType: '生鲜/电商',
  describe: '成都本地生鲜电商平台，用户通过平台可以享受当天采摘蔬菜水果',
  banner: [
      require('@/assets/images/worksPics/w6-b1.jpg'),
      require('@/assets/images/worksPics/w6-b2.jpg'),
      require('@/assets/images/worksPics/w6-b3.jpg'),
      require('@/assets/images/worksPics/w6-b4.jpg')
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '在线展示', url:'https://gofarms.lab.rollong.com  '},
        { intro: '管理后台（0001，qweasdzxc）', url:'https://gofarms.lab.rollong.com/admin'},
    ]
}

const work7 = {
  name: 'Enji工作室',
    cover: require('@/assets/images/worksPics/w7-cover.jpg'),
  date: '2014年10月',
  partner: '恩吉工作室',
  appType: 'web网站',
  industryType: '建筑/室内设计',
  describe: 'Studio Enji 装修管理系统，客户偏好测评、项目进度查看、在线合同',
  banner: [
      require('@/assets/images/worksPics/w7-b1.jpg'),
      require('@/assets/images/worksPics/w7-b2.jpg')
  ],
  bannerType: 'pc',
}

const work8 = {
  name: '广告监管系统',
    cover: require('@/assets/images/worksPics/w8-cover.jpg'),
  date: '2015年4月',
  partner: '中媒同业广告中心',
  appType: 'APP',
  industryType: '大数据系统',
  describe: '每日分析处理T级大数据信息，提取重要信息展示',
  banner: [
      require('@/assets/images/worksPics/w8-b1.jpg'),
      require('@/assets/images/worksPics/w8-b2.jpg'),
      require('@/assets/images/worksPics/w8-b3.jpg')
  ],
  bannerType: 'pc',

}

const work9 = {
  name: '智选派',
    cover: require('@/assets/images/worksPics/w9-cover.jpg'),
  date: '2016年11月',
  partner: '上海智伏企业管理有限公司',
  appType: 'APP',
  industryType: '餐饮/兼职',
  describe: '餐饮行业专供的兼职人员平台，滴滴模式，商户下单、兼职人员抢单完成服务、在线结算',
    banner: [
        require('@/assets/images/worksPics/w9-b1.jpg'),
        require('@/assets/images/worksPics/w9-b2.jpg'),
        require('@/assets/images/worksPics/w9-b3.jpg'),
        require('@/assets/images/worksPics/w9-b4.jpg')
    ],
    bannerType: 'mobile',
    demoUrls: [
        { intro: '官网地址', url:'https://zhixuanpai.com'}
    ]
}

const work10 = {
  name: '水利院工程进度管理平台',
    cover: require('@/assets/images/worksPics/w10-cover.jpg'),
  date: '2017年3月',
  partner: '四川省水利水电勘测设计研究院',
  appType: '微信公众号平台/后台管理',
  industryType: '内部管理',
  describe: '为四川省水利院定制开发的内部流程管理、交接、评分系统',
  banner: [
      require('@/assets/images/worksPics/w10-b1.jpg'),
      require('@/assets/images/worksPics/w10-b2.jpg'),
      require('@/assets/images/worksPics/w10-b3.jpg')
  ],
  bannerType: 'mobile',
}

const work11 = {
    name: '艺朴YEP',
    cover: require('@/assets/images/worksPics/w11-cover.jpg'),
    date: '2018年5月',
    partner: '四川宇修公关',
    appType: '微信小程序/后台管理',
    industryType: '艺术/展会',
    describe: '艺术展会、展馆资讯，在线购票，票务分销等一站式展会管理平台',
    banner: [
        require('@/assets/images/worksPics/w11-b1.jpg'),
        require('@/assets/images/worksPics/w11-b2.jpg'),
        require('@/assets/images/worksPics/w11-b3.jpg'),
        require('@/assets/images/worksPics/w11-b4.jpg')
    ],
    bannerType: 'mobile',
    qrLinks:[
        { title: '微信扫码体验', qrImg: require('@/assets/images/worksPics/w11-qr.jpg') },
    ]
}

const work12 = {
  name: '乐普斯™ 全流程系统',
    cover: require('@/assets/images/worksPics/w12-cover.jpg'),
  date: '2017年9月',
  partner: '乐普斯教育',
  appType: 'web网站/微信平台',
  industryType: '教育/留学',
  describe: 'Roopsi™是业内顶尖的留学申请机构，高端欧美留学、名校背景打造。',
  banner: [
      require('@/assets/images/worksPics/w12-b1.jpg'),
      require('@/assets/images/worksPics/w12-b2.jpg'),
      require('@/assets/images/worksPics/w12-b3.jpg')
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '官方网站', url: 'https://roopsi.com/' }
    ],
}

const work13 = {
  name: '甘肃铁塔工程管理系统',
  cover: require('@/assets/images/worksPics/w13-cover.jpg'),
  date: '2018年3月',
  partner: '中国铁塔集团甘肃省公司',
  appType: 'APP/管理后台',
  industryType: '工程管理',
  describe: '铁塔集团甘肃省公司定制开发的工程管理系统，涵盖铁塔施工、监理、运维和公司内部管理',
  banner: [
    require('@/assets/images/worksPics/w13-b1.jpg'),
    require('@/assets/images/worksPics/w13-b2.jpg'),
    require('@/assets/images/worksPics/w13-b3.jpg')
  ],
  bannerType: 'mobile',
    qrLinks:[
        { title: 'iOS扫码体验', qrImg: require('@/assets/images/worksPics/w13-qr.jpg') },
    ]
}

const work14 = {
  name: '宇修艺展平台-YEP',
  cover: null,
  date: '2018年4月',
  partner: '成都宇易文化传播有限公司',
  appType: '小程序',
  industryType: '艺术/展会',
  describe: '艺术类展览票务在线销售和核销服务系统',
  banner: [],
  bannerType: 'mobile',
}

const work15 = {
  name: '领军人脸识别门禁系统',
  cover: require('@/assets/images/worksPics/w15-cover.jpg'),
  date: '2018年5月',
  partner: '领军科技有限公司',
  appType: 'APP/管理后台',
  industryType: '人脸识别/教育',
  describe: '基于人脸识别的智能门禁系统，包含移动APP管理、现场摄像监控、管理后台等一系列软件',
  banner: [
    require('@/assets/images/worksPics/w15-b1.jpg'),
    require('@/assets/images/worksPics/w15-b2.jpg'),
    require('@/assets/images/worksPics/w15-b3.jpg'),
  ],
  bannerType: 'pc',
}

const work16 = {
  name: '危化品运输管理',
  cover: require('@/assets/images/worksPics/w16-cover.jpg'),
  date: '2018年6月',
  partner: '市政采购保密项目',
  appType: 'APP',
  industryType: '危化品',
  describe: '某市政采购项目（保密期内），涵盖车载监控、装卸监控、政府移动管理等',
  banner: [
    require('@/assets/images/worksPics/w16-b1.jpg'),
    require('@/assets/images/worksPics/w16-b2.jpg'),
    require('@/assets/images/worksPics/w16-b3.jpg'),
  ],
  bannerType: 'mobile',
}

const work17 = {
  name: 'OnCycle健身房',
  cover: require('@/assets/images/worksPics/w17-cover.jpg'),
  date: '2018年8月',
  partner: 'OnCycle',
  appType: '小程序',
  industryType: '健身',
  describe: 'onCycle室内单车健身中心 —— 单车上的派对',
  banner: [
    require('@/assets/images/worksPics/w17-b1.jpg'),
    require('@/assets/images/worksPics/w17-b2.jpg'),
    require('@/assets/images/worksPics/w17-b3.jpg'),
  ],
  bannerType: 'mobile',
  qrLinks:[
    { title: '扫码体验', qrImg: require('@/assets/images/worksPics/w17-qr.jpg') },
  ]
}

const work18 = {
  name: '餐悟',
  cover: require('@/assets/images/worksPics/w18-cover.jpg'),
  date: '2018年10月',
  partner: '筑必科技有限公司',
  appType: '微信公众号/管理后台',
  industryType: '餐饮/培训/社群',
  describe: '行业标准流程管理，排班和任务管理，人员绩效管理等一体化系统',
  banner: [
    require('@/assets/images/worksPics/w18-b1.jpg'),
    require('@/assets/images/worksPics/w18-b2.jpg'),
    require('@/assets/images/worksPics/w18-b3.jpg')
  ],
  bannerType: 'mobile',
    demoUrls: [
        { intro: '管理后台（rollong，password）', url: 'https://demo.canwu.zhonghuixz.com/front/dashboard/#/login' }
    ],
    qrLinks:[
        { title: '微信扫码体验', qrImg: require('@/assets/images/worksPics/w18-qr.jpg') }
    ]
}

const work19 = {
  name: 'WAF China 世界建筑节·中国',
  cover: require('@/assets/images/worksPics/w19-cover.jpg'),
  date: '2018年12月',
  partner: '上海普杏',
  appType: '小程序/web网站',
  industryType: '建筑/赛事报名',
  describe: 'WAF世界建筑节，中国区唯一官方平台。支持在线报名，在线支付等',
  banner: [
    require('@/assets/images/worksPics/w19-b1.jpg'),
    require('@/assets/images/worksPics/w19-b2.jpg'),
    require('@/assets/images/worksPics/w19-b3.jpg')
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '在线演示', url: 'https://www-alpha.wafchina.cn/#/' }
    ]
}

const work20 = {
  name: '美的厨房',
    cover: require('@/assets/images/worksPics/w20-cover.jpg'),
  date: '2013年8月',
  partner: '美的集团小家电事业部',
  appType: 'APP',
  industryType: '智能硬件控制',
  describe: 'APP选择菜谱，智能控制美的新品微波炉进行无人化烹饪',
    banner: [
        require('@/assets/images/worksPics/w20-b1.jpg'),
        require('@/assets/images/worksPics/w20-b2.jpg'),
        require('@/assets/images/worksPics/w20-b3.jpg')
    ],
    bannerType: 'mobile',
}

const work21 = {
  name: '玖意（demo方案）',
  cover: require('@/assets/images/worksPics/w21-cover.jpg'),
  date: '2019年3月',
  partner: '玖意装饰',
  appType: 'web网站',
  industryType: '家装',
  describe: '成都玖意装饰官方网站，案例展示、在线联系等',
  banner: [
    require('@/assets/images/worksPics/w21-b1.jpg'),
    require('@/assets/images/worksPics/w21-b2.jpg'),
    require('@/assets/images/worksPics/w21-b3.jpg')
  ],
  bannerType: 'pc',
  demoUrls: [
    { intro: 'demo1', url: 'https://demos.rollong.com/%E7%8E%96%E6%84%8F/demo1/' },
    { intro: 'demo2', url: 'https://demos.rollong.com/%E7%8E%96%E6%84%8F/demo2/' },
  ]
}

/* 主要展示案例 */

/* 次要展示案例 */

const work22 = {
  name: '川弓网站',
  cover: require('@/assets/images/worksPics/w22-cover.jpg'),
  date: '2013年12月',
  partner: '四川川弓建材机械股份公司',
  appType: 'web网站',
  industryType: '建材/机械',
  describe: '四川川弓建材机械股份公司全球推广网站',
  banner: [
      require('@/assets/images/worksPics/w22-b1.jpg'),
      require('@/assets/images/worksPics/w22-b2.jpg'),
      require('@/assets/images/worksPics/w22-b3.jpg')
  ],
  bannerType: 'pc'
}

const work23 = {
  name: '澳澳网',
    cover: require('@/assets/images/worksPics/w23-cover.jpg'),
  date: '2014年3月',
  partner: '澳澳进出口有限公司',
  appType: '微信公众号',
  industryType: '电商',
  describe: '顶级红酒进口商，澳大利亚五星级原瓶进口葡萄酒电商平台',
  banner: [
      require('@/assets/images/worksPics/w23-b1.jpg'),
      require('@/assets/images/worksPics/w23-b2.jpg')
  ],
  bannerType: 'mobile'
}

const work24 = {
  name: '四川省科社院留学中心',
    cover: require('@/assets/images/worksPics/w24-cover.jpg'),
  date: '2014年3月',
  partner: '四川省社科院',
  appType: 'web网站',
  industryType: '教育/留学',
  describe: '四川省社科院留学中心官网，项目介绍、在线报名',
  banner: [
      require('@/assets/images/worksPics/w24-b1.jpg'),
      require('@/assets/images/worksPics/w24-b2.jpg'),
      require('@/assets/images/worksPics/w24-b3.jpg')
  ],
  bannerType: 'pc',
}

const work25 = {
  name: '丝绸之路-英语朗读者',
    cover: require('@/assets/images/worksPics/w25-cover.jpg'),
  date: '2017年4月',
  partner: '英特思国际教育',
  appType: '微信公众号平台',
  industryType: '教育',
  describe: '陕西省丝绸之路青少年英语风采大赛 -- 在线初赛平台平台。全自动智能口语评分系统（base by 智能语音识别引擎™）',
  banner: [
      require('@/assets/images/worksPics/w25-b1.jpg'),
      require('@/assets/images/worksPics/w25-b2.jpg'),
      require('@/assets/images/worksPics/w25-b3.jpg'),
      require('@/assets/images/worksPics/w25-b4.jpg')
  ],
  bannerType: 'mobile',
}

const work26 = {
  name: '一庐购票',
    cover: require('@/assets/images/worksPics/w26-cover.jpg'),
  date: '2017年5月',
  partner: '一庐文化传播',
  appType: '微信公众号平台',
  industryType: '艺术/展会',
  describe: '艺术类展览票务在线销售+管理员核销系统',
  banner: [
      require('@/assets/images/worksPics/w26-b1.jpg'),
      require('@/assets/images/worksPics/w26-b2.jpg'),
      require('@/assets/images/worksPics/w26-b4.jpg'),
      require('@/assets/images/worksPics/w26-b3.jpg')
  ],
  bannerType: 'mobile',
}


const work27 = {
  name: '太空富翁',
    cover: require('@/assets/images/worksPics/w27-cover.jpg'),
  date: '2017年7月',
  partner: '筑必科技',
  appType: 'APP/管理后台',
  industryType: '电商代理平台',
  describe: '代理平台类电商，支持在线购物、代理申请，后台管理代理佣金返点',
  banner: [
      require('@/assets/images/worksPics/w27-b1.jpg'),
      require('@/assets/images/worksPics/w27-b2.jpg'),
      require('@/assets/images/worksPics/w27-b3.jpg')
  ],
  bannerType: 'mobile',
}

/* 次要展示案例 */


/* 自主项目展示案例 */



const selfWork1 = {
  name: '诺朗支付™️ Rollong Payment',
  cover: null,
  date: '2018年10月',
  partner: null,
  appType: 'APP/Web管理网站',
  industryType: '医院/医美支付',
  describe: '医疗行业信息化，在线支付系统',
  banner: [
      require('@/assets/images/worksPics/sw1-b1.jpg'),
      require('@/assets/images/worksPics/sw1-b2.jpg'),
      require('@/assets/images/worksPics/sw1-b3.jpg'),
      require('@/assets/images/worksPics/sw1-b4.jpg'),
      require('@/assets/images/worksPics/sw1-b5.jpg'),
      require('@/assets/images/worksPics/sw1-b6.jpg'),
  ],
  bannerType: 'pc',
    demoUrls: [
        { intro: '在线展示（商户号:1 登录:admin/123456）', url:'https://dashboard.payment-dev.rollong.com/#/login'}
    ]
}

const selfWork2 = {
  name: 'SunMall™',
  cover: null,
  date: '2017年10月',
  partner: null,
  appType: '小程序',
  industryType: '电商/小游戏',
  describe: '电商+小游戏，基于微信小程序',
  banner: [
      require('@/assets/images/worksPics/sw2-b1.jpg'),
      require('@/assets/images/worksPics/sw2-b2.jpg'),
      require('@/assets/images/worksPics/sw2-b3.jpg'),
      require('@/assets/images/worksPics/sw2-b4.jpg'),
      require('@/assets/images/worksPics/sw2-b5.jpg')
  ],
  bannerType: 'mobile',
    qrLinks:[
        { title: '微信扫码体验', qrImg: require('@/assets/images/worksPics/sw2-qr.jpg') },
    ]
}

const selfWork3 = {
    name: '卜丁坊® BedInFun®️',
    cover: null,
    date: '2016年4月',
    partner: null,
    appType: 'web',
    industryType: '电商系统',
    describe: '诺朗科技自营家纺电商平台，2016年上线',
    banner: [
        require('@/assets/images/worksPics/sw3-b1.jpg'),
        require('@/assets/images/worksPics/sw3-b2.jpg'),
        require('@/assets/images/worksPics/sw3-b3.jpg'),
        require('@/assets/images/worksPics/sw3-b4.jpg')
    ],
    bannerType: 'pc',
    demoUrls: [
        { intro: '在线展示', url:'https://bedinfun.com/'}
    ]
}


const selfWork4 = {
    name: '三餐三饮™ 餐饮SaaS系统',
    cover: null,
    date: '2017年6月',
    partner: '三餐三饮智能科技（诺朗参股）',
    appType: 'SaaS平台',
    industryType: '餐饮',
    describe: '餐饮行业全功能SaaS：店面收银、移动点菜、店长管理、排队叫好、会员管理等八大软件。' +
    '营销、优惠由管理层决策，支持『一司多店』（加盟经营，分店拓展）',
    banner: [
        require('@/assets/images/worksPics/sw4-b1.jpg'),
        require('@/assets/images/worksPics/sw4-b2.jpg'),
        require('@/assets/images/worksPics/sw4-b3.jpg')
    ],
    bannerType: 'pc',
    demoUrls: [
        { intro: '官网地址', url:'https://3c3y.cn/'}
    ]
}

/* 自主项目展示案例 */

// 2013年项目
export const year2013works = {
  title: '2013年 案例',
  describe: "2013 works's describe",
  list: [
    [
      work3,
      work20,
      work22
    ]
  ]
}

// 2014年项目
export const year2014works = {
  title: '2014年 案例',
  describe: "2014 works's describe",
  list: [
    [work4,
      work5,
      work6
    ],
    [
      work7,
      work23,
      work24
    ]
  ]
}

// 2015年项目
export const year2015works = {
  title: '2015年 案例',
  describe: "2015 works's describe",
  list: [
    [work1,
      work2,
      work8
    ]
  ]
}


// 2016 && 2017年项目
export const year201617works = {
  title: '2016 && 2017年 案例',
  describe: "2016 && 2017 works's describe",
  list: [
    [
      work9,
      work10,
        work27
    ],
    [
      work12,
      work25,
      work26
    ]
  ]
}

// 2018年项目
export const year2018works = {
  title: '2018年 案例',
  describe: "2018 works's describe",
  list: [
    [work13, work15, work16],
    [work11, work18, work19],
    [work17, work21 ]
  ]
}

// 自主项目展示案例
export const selfWorks = [selfWork1, selfWork3, selfWork2, selfWork4]